import { TypePolicies } from "@apollo/client";
import { mergePaginatedResults, readPaginatedResults } from "@flixbus-phx/marketplace-common";
import getNumberForPageSize from "../../shared/helpers/getNumberForPageSize/getNumberForPageSize";

const typePolicies: TypePolicies = {
  Query: {
    fields: {
      filterRides: {
        // How this works: https://www.apollographql.com/docs/react/pagination/core-api/#merging-paginated-results
        keyArgs: ["rideFilter", "sort"],
        read: (...params) => readPaginatedResults(...params, getNumberForPageSize),
        merge: (...params) => mergePaginatedResults(...params, getNumberForPageSize),
      },
    },
  },
  Capacity: {
    merge: true,
  },
  Partner: {
    keyFields: ["contractPartnerId"],
  },
};

export default typePolicies;
